<div class="array-container">
  @if (visibleItems.length > 0) {
  <div class="array-item" *ngFor="let item of visibleItems">
    {{ formatItem(item) }}
  </div>
  <button
    *ngIf="remainingCount > 0"
    type="button"
    class="array-more"
    (click)="onMoreClick($event)"
  >
    +{{ remainingCount }}
  </button>
  } @else {
    <span class="content-empty">—</span>
  }
</div>

